import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {

  constructor() { }
  setItem(name: string, value: any) {
    localStorage.setItem(name, value);
  }

  removeItem(name: string) {
    localStorage.removeItem(name);
  }

  getItem(name: string): any {
    return localStorage.getItem(name);
  }
}
